<script>
    import { setContext, onMount, onDestroy } from "svelte";
    import "../../../../node_modules/mapbox-gl/dist/mapbox-gl.css";
    import { key, Map } from "./mapbox.js";
    import { arrayFromCoordinateDirctionary } from "../../../helpers/geo.js";

    export let window;
    export let center = { latitude: 39, longitude: -98 };
    export let zoom = 13;

    let map;
    let isLoaded;
    let container;
    let observer;

    $: container && observer && observer.observe(container);

    if (typeof ResizeObserver !== "undefined") {
        let resizeTimer;

        observer = new ResizeObserver(() => {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
                if (map) {
                    map.resize();
                }
            }, 10);
        });

        onDestroy(() => {
            observer.unobserve(container);
        });
    }

    setContext(key, {
        map() {
            return map;
        }
    });

    function load() {
        map = new Map({
            container,
            style: "mapbox://styles/mapbox/outdoors-v12?optimize=true",
            center: arrayFromCoordinateDirctionary(center),
            zoom,
            maxZoom: 18,
            accessToken: process.env.MAPBOX_TOKEN,
            projection: "mercator"
        });

        map.dragRotate.disable();
        map.touchZoomRotate.disableRotation();

        map.once("style.load", () => {
            isLoaded = true;
        });
    }

    function didRequestViewportChange(e) {
        if (e.detail.window !== window.id) {
            return;
        }

        if (!isLoaded) {
            map.on("load", () => {
                didRequestViewportChange(e);
            });

            return;
        }

        map.flyTo({
            center: arrayFromCoordinateDirctionary(e.detail),
            zoom: e.detail.zoom || 13,
            speed: 5,
            curve: 1
        });
    }

    globalThis.addEventListener("map:viewport", didRequestViewportChange);

    onMount(load);

    onDestroy(() => {
        globalThis.removeEventListener(
            "map:viewport",
            didRequestViewportChange
        );

        if (map) {
            map.remove();
        }
    });
</script>

<div class:loaded={isLoaded} bind:this={container}>
    {#if map}
        <slot />
    {/if}
</div>

<style>
    div {
        opacity: 0;
        width: 100%;
        height: 100%;
    }

    .loaded {
        opacity: 1;
    }
</style>
